// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__8nq_L","wide":"Button_wide__EZ_C8","background":"Button_background__bojcT"};